import { cloneElement, isValidElement, ReactElement, ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LoginGate } from "./LoginGate";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

type AuthState =
  | { status: "checking"; user: null }
  | { status: "authed"; user: Record<string, unknown> }
  | { status: "guest"; user: null };

export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const passedUser = (location.state as { user?: Record<string, unknown> } | null)?.user;
  const [auth, setAuth] = useState<AuthState>(
    passedUser ? { status: "authed", user: passedUser } : { status: "checking", user: null },
  );

  useEffect(() => {
    if (passedUser) return;
    const checkAuth = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, { credentials: "include" });
        if (!res.ok) throw new Error("not authenticated");
        setAuth({ status: "authed", user: await res.json() });
      } catch {
        setAuth({ status: "guest", user: null });
      }
    };
    checkAuth();
  }, [passedUser]);

  if (auth.status === "checking") {
    return (
      <div data-testid="auth-checking" className="flex min-h-screen items-center justify-center bg-black">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-krono">Verificando acesso…</span>
      </div>
    );
  }
  if (auth.status === "guest") return <LoginGate />;
  return <>{isValidElement(children) ? cloneElement(children as ReactElement<{ user?: unknown }>, { user: auth.user }) : children}</>;
};
